import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "under" }, "アップカメラ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "privacy-policy-item" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "under" }, "■機能概要■")
  ]),
  /*#__PURE__*/_createElementVNode("pre", null, "      本アプリをご利用いただき、ありがとうございます。このアプリは、\n      撮影した写真をGoogleDrive上にフォルダを作成して保存できるカメラアプリです。\n      スマホのカメラ機能で撮影した写真を、\n      「GoogleDrive上にアップロードし、作成したフォルダに格納して管理する」\n      といった少し面倒な作業をこのアプリだけで簡単に実現できます。\n      また、写真ファイルををスマホに残さないため、スマホの容量節約も可能です。\n    ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "privacy-policy-item" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "under" }, "■基本的な使い方■")
  ]),
  /*#__PURE__*/_createElementVNode("pre", null, [
    /*#__PURE__*/_createTextVNode("      使い方は以下になります。\n      1.アプリで写真を撮影します。※写真は複数撮影可能です。\n\n      2.撮影した写真をGoogle Driveにアップロードして保存することができます。\n        その時、Google Drive上で写真を格納するフォルダを作成できます。\n\n      3.アップロードした写真はアプリユーザの方が所有するアカウントのGoogle Driveに保存されます。\n\n      ↓↓↓また、本アプリの使い方は以下のYoutube動画からも確認できます。※英語ですが…↓↓↓\n      "),
    /*#__PURE__*/_createElementVNode("iframe", {
      width: "560",
      height: "315",
      src: "https://www.youtube.com/embed/creJmZ7HJ0c",
      title: "YouTube video player",
      frameborder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: ""
    }),
    /*#__PURE__*/_createTextVNode("\n    ")
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "privacy-policy-item" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "under" }, "■詳細な使い方■")
  ]),
  /*#__PURE__*/_createElementVNode("pre", null, "      本アプリケーションの画面ごとの詳細な使い方について、\n      以下に記載いたします。\n    "),
  /*#__PURE__*/_createElementVNode("h4", null, "写真一覧画面"),
  /*#__PURE__*/_createElementVNode("pre", null, "      右下のカメラボタンから写真を撮影します。\n      撮影して保存すると、写真一覧画面に、\n      撮影した写真の画像と撮影日時が表示されます。\n      写真は右下のカメラボタンから何枚でも撮影が可能です。\n    "),
  /*#__PURE__*/_createElementVNode("h4", null, "写真プレビュー画面"),
  /*#__PURE__*/_createElementVNode("pre", null, "      写真一覧画面で撮影した写真をタップすると、写真プレビュー画面に移動します。\n      この画面で、撮影した写真をチェックすることが可能です。\n      撮り直したい場合は、この画面下部の「撮り直す」ボタンから\n      再度カメラを起動して撮り直すことができます。\n      撮り直した写真は一覧画面に表示されます。\n    "),
  /*#__PURE__*/_createElementVNode("h4", null, "写真アップロード画面"),
  /*#__PURE__*/_createElementVNode("pre", null, "      撮影した写真をGoogleDrive上にフォルダを作成して保存できます。\n      画面真ん中の空欄にGoogleDrive上で写真を保存するためのフォルダ名を入力できます。\n      その後「実行」ボタンをタップすると、GoogleDrive上に入力した名前のフォルダが作られ、その中に写真が保存されます。\n      何も入力しない場合はNewFolderというフォルダがGoogleDrive上に作られ、その中に写真が保存されます。\n      写真を複数枚撮影した場合は、その写真全部がこちらで入力したフォルダの中に格納されます。\n\n      ※アップロード時は、Googleへのサインイン画面が開きますので、Googleアカウントを事前に用意することをお勧めします。\n      ※Google、Googleドライブは、Google Inc. の商標または登録商標です。\n    ")
], -1)
const _hoisted_6 = { class: "privacy-policy-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "under" }, "■プライバシーポリシー■")
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("      本アプリのプライバシーポリシーは")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("こちらから")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("確認できます。\n    ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_back_to_home_button = _resolveComponent("back-to-home-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("pre", null, [
          _hoisted_8,
          _createVNode(_component_router_link, { to: { path: 'up-camera-privacypolicy'} }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _hoisted_10
        ])
      ])
    ]),
    _createVNode(_component_back_to_home_button)
  ], 64))
}